import { PersonaPicture } from '@/pages/main/managePersonas/types';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class PersonaPictureUploaded extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'PersonaPictureUploaded';

    public constructor(public picture: PersonaPicture) {
        super(PersonaPictureUploaded.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: PersonaPictureUploaded): void => {
    state.personaPictures.push(action.picture);
};

//@ts-ignore
registerReducer(PersonaPictureUploaded.ACTION_TYPE, reducer);
